import { DEFAULT_CENSOR_MASK, SYSTEM_USER } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { mutateObject } from 'cpool-utils';
import { z } from 'zod';

import type { EventSchema } from '../../../utils/EventSchema';
import { _Event } from '../../_Event';

export class LoanRequest_SystemNoteAdded extends _Event {
    getSchema() {
        return z.object({
            content: z.string().min(1),
            favored: z.boolean().default(false),
            id: schemaId,
            issuer: z.union([schemaId, z.literal(SYSTEM_USER.id)]).optional(),
        });
    }

    static example(): EventSchema<LoanRequest_SystemNoteAdded> {
        return {
            content: 'LEADS.DETAILS.SYSTEM_NOTES.CO_APPLICANT_CENSORED',
            favored: false,
            id: '7f2def23-f1ad-4c6b-9c84-1218e0c794e7',
        };
    }

    getCensoredSchema() {
        return this.getSchema().transform((data) => mutateObject(data, { content: DEFAULT_CENSOR_MASK }));
    }
}
